import React from 'react';
import { Section } from './ui/Section';
import { AlertCircle, XCircle } from 'lucide-react';
export function ProblemSection() {
  return <Section className="bg-tactical-surface/50 border-y border-tactical-surface2" data-id="element-190">
      <div className="max-w-3xl mx-auto" data-id="element-191">
        <div className="text-center mb-12" data-id="element-192">
          <h2 className="text-3xl md:text-4xl text-tactical-cyan mb-6" data-id="element-193">
            The "Reaction Gap"
          </h2>
          <p className="text-xl text-slate-300 font-inter leading-relaxed" data-id="element-194">
            You've seen it happen. Your child is open, the ball is coming, but
            they are{' '}
            <span className="text-white font-semibold" data-id="element-195">"ball-locked."</span> By
            the time they receive it and look up, the window has closed. The
            defender is already there. The opportunity is gone.
          </p>
        </div>

        <div className="bg-tactical-dark border border-tactical-surface2 rounded-xl p-8 mb-12 relative overflow-hidden" data-id="element-196">
          <div className="absolute top-0 right-0 w-32 h-32 bg-red-500/5 blur-[80px] rounded-full" data-id="element-197"></div>

          <div className="flex items-start gap-4 mb-6" data-id="element-198">
            <AlertCircle className="w-8 h-8 text-red-400 shrink-0 mt-1" data-id="element-199" />
            <div data-id="element-200">
              <h3 className="text-2xl mb-2" data-id="element-201">The Real Problem</h3>
              <p className="text-slate-400 font-inter leading-relaxed" data-id="element-202">
                Most youth players are coached to focus entirely on their feet.
                They spend years mastering the ball but zero hours mastering the
                field. This creates a{' '}
                <strong className="text-white" data-id="element-203">"Reaction Gap"</strong>—a
                fraction of a second where they are frozen, waiting for their
                brain to catch up to the game.
              </p>
              <p className="text-slate-400 font-inter leading-relaxed mt-4" data-id="element-204">
                In competitive travel soccer, that delay is the difference
                between a D1 scholarship and a seat on the bench. If your child
                is constantly surprised by defenders or "looks lost" in
                high-pressure games, they aren't lacking talent—they are lacking
                a mental map.
              </p>
            </div>
          </div>
        </div>

        <div className="space-y-6" data-id="element-205">
          <h3 className="text-2xl text-center mb-8" data-id="element-206">
            Why What You Tried Didn't Work
          </h3>

          {["Standard cone drills only teach players to look at the ground, reinforcing the 'ball-locked' habit.", "Telling a child to 'look around' is too vague; they don't know when to look or what they are looking for.", "Playing more games doesn't help if they are simply repeating the same blind habits under higher stress.", "Private technical trainers often ignore the cognitive 'trigger moments' that dictate elite play."].map((item, i) => <div key={i} className="flex items-center gap-4 bg-tactical-surface p-4 rounded-lg border border-tactical-surface2" data-id="element-207">
              <XCircle className="w-6 h-6 text-slate-500 shrink-0" data-id="element-208" />
              <p className="text-slate-300 font-inter" data-id="element-209">{item}</p>
            </div>)}
        </div>
      </div>
    </Section>;
}